import BaseParentalEmail from 'registration/js/base/fields/parental_email';

import template from 'registration/templates/dark/fields/parental_email.html';

const ParentalEmail = BaseParentalEmail.extend({
    template,
});

export default ParentalEmail;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/dark/fields/parental_email.js